import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function usePrepareDelete(projectId) {
  return useMutation({
    mutationFn: async () => (await apiClient.post(`/projects/${projectId}/delete/prepare`)).data,
  });
}

export function useConfirmDelete(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ token, confirmName }) =>
      (await apiClient.post(`/projects/${projectId}/delete/confirm`, { token, confirm_name: confirmName })).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}
